import Vue from "vue";
import Vuex from "vuex"
import infosignal from "./modules/infosignal";
import VuexPersistence from 'vuex-persist' // 将vuex数据存储至localstorage
Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  storage: window.localStorage
})

const store = new Vuex.Store({
  modules: { infosignal },
  plugins: [vuexLocal.plugin]
});

export default store;